import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { BannerNotification } from '../../common/models/BannerNotification';
import { CommonModule } from '@angular/common';
import { CentruiButtonIconComponent } from "../../centrui/src/app/components/centrui-button-icon/centrui-button-icon.component";
import { ModalService } from '../../centrui/src/app/services/modal.service';
import { LogService } from '../../centrui/src/app/services/log.service';
import { LogEvent } from '../../centrui/src/app/constants/LogEvent';
import { ModalComponent } from '../../centrui/src/app/components/modal/modal.component';
@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
  imports: [CommonModule, CentruiButtonIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})

export class NotificationBannerComponent implements OnInit {

  @Input() bannerNotification!: BannerNotification;

  constructor(
    private modalService: ModalService,
    private logService: LogService
  ) { }

  ngOnInit(): void {

  }

  close() {
    this.modalService.open(ModalComponent, {
      title: 'Acknowledgement',
      text: '<strong>' + this.bannerNotification.content + '</strong> <br/><br/>By closing this banner you acknowledge that you have read and understood the information provided.',
      confirmButtonText: 'I understand',
      style: 'primary'
    }).subscribe(result => {
      if(!result.hasData()) return;
      const now = new Date();
      localStorage.setItem('bannerNotification' + this.bannerNotification.id, JSON.stringify({
        closed: true,
        expiry: now.getTime() + (1000 * 60 * 60 * 24) // 1 day
      }));
      this.logService.createLog(LogEvent.VIEWED, BannerNotification, this.bannerNotification);
    });
  }

}
